<template>
  <div v-for="(item, index) in epgData"
       :key="`${item.channel.originId}-${index}`"
       class="bx-epg-search__row"
       :class="{'bx-js--single-broadcast': item.broadcasts.length === 1}">
    <Channel :channel="item.channel" />
    <div>
      <Broadcast v-for="broadcast in sliceBroadcasts(item.broadcasts)"
                 :key="broadcast.originId"
                 :broadcast="broadcast" />
    </div>
  </div>
</template>

<script>
import Channel from './Channel.vue'
import Broadcast from './Broadcast.vue'

export default {
  components: {
    Channel,
    Broadcast
  },
  props: {
    epgData: {
      type: Array,
      default: () => []
    },
    viewMode: {
      type: String,
      default: 'overview' // or "channel"
    }
  },
  methods: {
    sliceBroadcasts (broadcasts) {
      if (broadcasts.length > 2) {
        console.warn('EpgSearch/BroadcastList.vue: more than two broadcasts available for channel')
      }
      // only show 2 broadcasts in overview mode
      return this.viewMode === 'overview' ? broadcasts.slice(0, 2) : broadcasts
    }
  }
}
</script>
